export const genreOptions = [
  '动作', '爱情', '喜剧', '科幻', '悬疑', '犯罪', '剧情', '古装',
  '战争', '青春', '家庭', '美食', '音乐', '户外', '脱口秀', '谍战', '冒险', '竞技',
];

export const regionOptions = ['中国', '美国', '日本', '韩国', '英国', '法国'];

export const yearOptions = [2024, 2023, 2022, 2021, 2020];

export const sortOptions = [
  { value: 'latest', label: '最新上映' },
  { value: 'hot', label: '最热门' },
  { value: 'rating', label: '评分最高' },
] as const;

export type SortValue = typeof sortOptions[number]['value'];